<template>
  <div>
    <vs-prompt
      title="Select a Sales Product to add"
      @cancel="val = ''"
      @accept="accept"
      :active.sync="prompt"
      accept-text="Add product"
      :is-valid="validForm"
      class="add-stock-transfer-product-popup"
    >
      <div class="data-list-container data-list-list-view">
        <vs-table
          v-if="filteredProducts"
          ref="table"
          class="mt-8"
          pagination
          search
          maxItems="6"
          v-model="selectedProduct"
          :data="filteredProducts"
          noDataText="No data"
        >
          <template slot="thead">
            <vs-th sort-key="id">Id</vs-th>
            <vs-th sort-key="name">Name</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                <vs-td>
                  <div
                    class="product-name font-medium truncate flex flex-row items-center"
                  >
                    <img width="40" :src="ProductIcon" />
                    <p class="ml-4">{{ tr.number }}</p>
                  </div>
                </vs-td>
                <vs-td>
                  {{ tr.name }}
                </vs-td>

                <!-- <vs-td>
                  {{ tr.productCategoryId }}
                </vs-td>

                <vs-td>
                  {{ tr.pouringCategoryId }}
                </vs-td> -->
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import ProductIcon from "@/assets/images/product-icon.png";
export default {
  data() {
    return {
      moment,
      ProductIcon,

      prompt: false,
      selectedProduct: null,
    };
  },
  emits: ["onSelected"],
  props: {
    alreadySelectedProducts: {
      type: Array,
      default: () => [],
    },
    selectableSalesProducts: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({}),
    validForm() {
      return this.selectedProduct != null;
    },

    // Filter out products already in the form
    filteredProducts() {
      if (!this.selectableSalesProducts) {
        return [];
      }

      return this.selectableSalesProducts
        .filter((e) => {
          return !this.alreadySelectedProducts.some((p) => p.id === e.id);
        })
        .filter((e) => e.salesProductType === "Stock"); // You can only select stock type sales products, to avoid recursive sales products
    },
  },
  methods: {
    async show() {
      this.prompt = true;
    },
    async accept() {
      this.$emit("onSelected", this.selectedProduct);
    },
  },
};
</script>

<style lang="scss">
.add-stock-transfer-product-popup {
  z-index: 52011;

  .vs-dialog {
    max-width: 900px;

    .vs-dialog-text {
      background-color: #f8f8f8;
    }

    .header-table.vs-table--header {
      margin-left: 0 !important;
    }
  }
}
</style>
